import { Component, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-monitoring",
  templateUrl: "./monitoring.component.html",
  styleUrls: ["./monitoring.component.scss"],
})
export class MonitoringComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
